import React from 'react';
import Button from 'jbc-front/components/Button';
import { useEmployeeMutation } from '@jbc-year-end-adj/2024/hooks/graphql/useMutation';
import { ButtonContainer as Buttons } from '@jbc-year-end-adj/2024/features/questions/components/ButtonContainer/ButtonContainer';
import useReactRouter from 'use-react-router';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { ResignInYear as ResignInYearTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/ResignInYear';
import { ANSWER_RESIGN_IN_YEAR } from './ResignInYearMutation';

interface ResignInYearProps {
  question: Question;
}

export const ResignInYear = ({ question }: ResignInYearProps) => {
  const [answer, { loading }] = useEmployeeMutation(ANSWER_RESIGN_IN_YEAR);
  const { history } = useReactRouter();

  const handleResignAnswer = async (isResign: boolean) => {
    await answer({ variables: { answer: isResign } });
    history.push('/employee_input');
  };

  return (
    <ResignInYearTemplate question={question}>
      <Buttons>
        <Button huge secondary disabled={loading} onClick={() => handleResignAnswer(true)}>
          退職予定です
        </Button>
        <Button huge secondary disabled={loading} onClick={() => handleResignAnswer(false)}>
          退職予定はありません
        </Button>
      </Buttons>
    </ResignInYearTemplate>
  );
};
